import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function FAQ() {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Container id="faq" sx={sxMainContainer}>
      <Typography
        component="h2"
        variant="h4"
        color="text.primary"
        sx={sxFAQTitle}
      >
        Perguntas frequentes
      </Typography>
      <Box sx={{ width: "100%" }}>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2d-content"
            id="panel2d-header"
          >
            <Typography
              component="h1"
              variant="body1"
              sx={{
                maxWidth: {
                  color: "#233158",
                  sm: "100%",
                  md: "70%",
                },
              }}
            >
              Como posso baixar os arquivos CSVs utilizados como padrão?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              gutterBottom
              sx={{ maxWidth: { sm: "100%", md: "70%" } }}
            >
              Pode baixar os arquivos CSVs utilizados como padrão clicando
              nestes links:
              <br />
              <a href="csv/Comptenecias_template.csv" download>
                Competencias
              </a>
              <br />
              <a href="csv/feedback_template.csv" download>
                Feedback
              </a>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1d-content"
            id="panel1d-header"
          >
            <Typography
              component="h3"
              variant="subtitle2"
              sx={{
                maxWidth: {
                  color: "#233158",
                  sm: "100%",
                  md: "70%",
                },
              }}
            >
              Como entro em contato com o suporte ao cliente se tiver alguma
              dúvida ou problema?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              gutterBottom
              sx={{ maxWidth: { sm: "100%", md: "70%" } }}
            >
              Você pode entrar em contato com nossa equipe de suporte ao cliente
              enviando um e-mail para
              <Link href="mailto:atendimento@pansolutions.com.br">
                {" "}
                atendimento@pansolutions.com.br{" "}
              </Link>
              . Estamos aqui para ajudá-lo prontamente.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  );
}

const sxMainContainer = (theme: { palette: { mode: string } }) => ({
  pt: { xs: 4, sm: 12 },
  pb: { xs: 8, sm: 16 },
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: { xs: 3, sm: 6 },
});

const sxFAQTitle = (theme: { palette: { mode: string } }) => ({
  width: { sm: "100%", md: "60%" },
  textAlign: { sm: "left", md: "center" },
});
